import Container from 'components/container/Container';
import ios from './ios.svg';
import android from './android.svg';
import Logout from '../logout/Logout';

const Success = () => {
  return (
    <Container>
      <div className="max-w-[500px] px-4">
        <label className="font-medium text-left text-brand-forest mb-2 inline-block">
          Step 4 of 4
        </label>
        <h1 className="text-3xl font-bold mb-4 text-brand-forest">
          Download the app and login to start sharing the care
        </h1>
        <p>
          Thank you for joining HaltH. HaltH offers members access to unlimited
          content, accessing additional feature and recommendations to the whole
          family, because HaltH is about the collective starting at home.
        </p>
        <div className="flex text-center items-center gap-2 justify-center my-4">
          <a href="https://apps.apple.com/us/app/halth/id1621905859">
            <img src={ios} alt="HaltH iOS app" />
          </a>
          <img src={android} alt="HaltH android app" />
        </div>
        <div className="mb-2 flex justify-center">
          <Logout className="max-w-[200px]" />
        </div>
      </div>
    </Container>
  );
};

export default Success;
